import MinAndStandardLabelContext from "./MinAndStandardLabelContext"

const MinAndStandardLabelProvider = ({
  children,
  ...props
}: {
  minId?: string
  standardId?: string
  children: React.ReactNode
}) => {
  return <MinAndStandardLabelContext.Provider value={props}>{children}</MinAndStandardLabelContext.Provider>
}

export default MinAndStandardLabelProvider
